import React from "react";
import styled from "styled-components";

import UtilityLink from "@util/standardize-link";

import theme from "@theme";

const { font, colors } = theme;

const LinkStyle = styled(UtilityLink)`
	font-family: ${font.bold};
	font-size: 16px;
	color: ${(props) => props.color || colors.newBrand.turquoise};
	text-decoration: underline;

	:hover {
		color: ${colors.newBrand.darkTurquoise};
		text-decoration: underline;
	}
`;

const Link = ({ linkWrapper, to, anchorLink, linkText, color, arrow, className, style, children,  ...props }) => {
	return (
		// for things like wrapping an image or other use cases where you don't want the base style. 
		linkWrapper ? (
			<UtilityLink className={className} to={to} color={color} style={style} anchorLink={anchorLink} {...props}>
				{children}
			</UtilityLink>
		) : (
			<LinkStyle className={className} to={to} color={color} style={style} anchorLink={anchorLink} {...props}>
				{children}
			</LinkStyle>
		)
	);
};

export default Link;
